module.exports = __webpack_public_path__ + "static/media/ic_conduite_chariot_white.ae8831b3.svg";